// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c86a0e10","207":"793e87e0","531":"0d2899fa","726":"5d3905e4","967":"fa8b5e49"}[chunkId] + ".chunk.js";
};